import { AxiosError } from "axios";

export interface ProblemDetails {
  readonly detail: string;
}

export interface StatusAndProblemDetails {
  readonly status: string;
  readonly detail: string;
}

export function handleError(error: AxiosError) {
  const problemDetails = error?.response?.data as ProblemDetails;

  if (problemDetails) {
    return new Error(problemDetails.detail);
  }

  return new Error("test-message");
}
